module.exports = __webpack_public_path__ + "media/images/common/header-81ead6526edefede77e837008df4c398.png";